import React from "react";

const ArrowDownIcon = ({ ...props }) => {
  return (
    <svg
      {...props}
      width="15"
      height="8"
      viewBox="0 0 15 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_186_203)">
        <path
          d="M1.61621 1L7.61621 7L13.6162 1"
          stroke="#071441"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_186_203">
          <rect
            width="14"
            height="8"
            fill="white"
            transform="translate(0.616211)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ArrowDownIcon;
